// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"65eace9f","394":"9ea8c26a","488":"e9eaf7d6","540":"01497059","815":"bfec9d76","862":"c7b8c65b"}[chunkId] + ".css";
};